import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import { ListItemButton } from '@wix/da-ds/pkg/List/ListItem';
import { BiData, BiContextProvidedValue, ClickCopyBiEvent } from '@wix/da-bi/pkg/events';
import { DeviationResourceType } from '../../../types/deviation';
import { useCopyDeviationLinkClick } from '../../../utils/hooks/useCopyLinkClick';

export interface Props {
  deviation: PapiDeviation;
  stopPropagation?: boolean;
}

const ShareOnSocial: React.FC<Props> = ({ deviation, stopPropagation }) => {
  const { t } = useTranslation();
  const { onCopyLinkClick } = useCopyDeviationLinkClick(deviation);

  return (
    <>
      <ListItemButton
        label={t('share.copyLink')}
        onClick={onCopyLinkClick}
        stopPropagation={stopPropagation}
        biData={BiData<ClickCopyBiEvent>({
          evid: 357,
          typeid: DeviationResourceType.TIER,
          itemid: deviation.deviationId,
          sectionname: BiContextProvidedValue,
        })}
        fillContainerWidth
      />
    </>
  );
};
ShareOnSocial.displayName = 'ShareOnSocial';

export default ShareOnSocial;
